import {EuiDescribedFormGroup, EuiFieldText, EuiFormRow, EuiLink, EuiRadioGroup, EuiSelect,} from "@elastic/eui";
import {useField, useFormikContext} from "formik";
import {observer} from "mobx-react-lite";
import React, {Fragment, useContext, useEffect, useState} from "react";
import {Branch, Lookup} from "../../../app/models/country";
import {Store} from "../../../app/stores/store-root";
import * as _ from 'lodash';
import {DeliveryBranches} from "../../../app/api/data/deliveryBranches";
import {DeliveryBanks, transformedBankBranches, transformedBanks} from "../../../app/api/data/BankBranches";

type TransferTypeSectionProps = {
    readonly?: boolean
}
const TransferTypeSection = ({readonly}: TransferTypeSectionProps) => {
    const store = useContext(Store);
    const cashierDisabled =  store.Users.isCashier === true ? readonly: "";
    const formik = useFormikContext();
    const {transferTypes} = store.Lookups;
    const [selectedTransferType, setSelectedTransferType] = useState<string>("");
    const [offices, setOffices] = useState<{ value: string; text: string }[]>(
        []
    );
    const [deliveryBanks, setDeliveryBanks] = useState<{ value: string; text: string }[]>(
        []
    );
    const [bankBranches, setBankBranches] = useState<{ value: string; text: string, bank: string }[]>(
        []
    );

    const [bankAccount, setBankAccount] = useState();
    const [bank, setBank] = useState("");
    const [bankBranch, setBankBranch] = useState();

    const [selectedBranch, setSelectedBranch] = useState<string>("");
    const [
        deliveryTypeField,
        deliveryTypeMeta,
        deliveryTypeFieldHelper,
    ] = useField("DeliveryType");
    const [branchField, branchFieldMeta, branchFieldHelper] = useField(
        "DeliveryOffice"
    );
    const [zobaField, zobaFieldMeta, zobaFieldHelper] = useField(
        "DeliveryOfficeZoba"
    );

    const [bankField, bankFieldMeta, bankFieldHelper] = useField("DeliveryBank");
    const [bankBranchField, bankBranchMeta, bankBranchHelper] = useField(
        "DeliveryBankBranch"
    );
    const [
        bankAccountField,
        bankAccountFieldMeta,
        bankAccountFieldHelper,
    ] = useField("DeliveryBankAccount");

    //initialize form
    useEffect(() => {
        setSelectedTransferType(deliveryTypeField.value);
        setSelectedBranch(branchField.value);
        setBank(bankField.value);
        setBankBranch(bankBranchField.value);
        setBankAccount(bankAccountField.value);
    }, [deliveryTypeField.value, branchField.value, bankField.value, bankBranchField.value, bankAccountField.value])

    const onChange = (id: string) => {
        setSelectedTransferType(id);
        deliveryTypeFieldHelper.setValue(id);
    };

    const onBankChange = (e: any) => {
        bankFieldHelper.setValue(e.target.value);
        setBank(e.target.value);
        console.log(e.target.value);
        const filtered = transformedBankBranches().filter((branch) => {
            console.log(branch)
            return branch.bank === e.target.value
        })
        filtered.splice(0, 0, {value: '', text: 'Select a bank branch', bank: ''});
        setBankBranches(filtered);
    };
    const onBankBranchChange = (e: any) => {
        bankBranchHelper.setValue(e.target.value);
        setBankBranch(e.target.value);
    };
    const onBankAccount = (e: any) => {
        bankAccountFieldHelper.setValue(e.target.value);
        setBankAccount(e.target.value);
    };

    const onBranchChange = (e: any) => {
        const value = e.target.value;
        const branch = _.find<Branch>(DeliveryBranches, (item: Branch) => item.value === value);
        branchFieldHelper.setValue(value);
        zobaFieldHelper.setValue(branch?.zoba);
        setSelectedBranch(e.target.value);
    };

    useEffect(() => {
        const transformedBranches = store.Lookups.branchRegistry.map(
            (item: Lookup) => {
                return {value: item ? item.value ?? "MK" : "Not", text: item.label};
            }
        );

        let banks = transformedBanks();
        let bankBranches = transformedBankBranches();

        banks.splice(0, 0, {value: '', text: 'Select a bank'});
        bankBranches.splice(0, 0, {value: '', text: 'Select a branch',bank:''});
        setOffices(transformedBranches);
        setDeliveryBanks(banks);
        setBankBranches(bankBranches);

    }, [store.Lookups.branchRegistry]);

    return (
        <Fragment>
            <EuiDescribedFormGroup
                title={<h3>Transfer Type</h3>}
                description={
                    <Fragment>
                    For bank transfers please insure the bank details are correct
                    </Fragment>
                }
            >
                <EuiFormRow
                    label="Transfer Types"
                    isInvalid={(deliveryTypeMeta.error && deliveryTypeMeta.touched) ? true : false}
                    error={deliveryTypeMeta.error}
                >
                    <EuiRadioGroup
                        options={transferTypes}
                        onChange={(id) => onChange(id)}
                        idSelected={selectedTransferType}
                        name="Transfer Type"
                        disabled={readonly}
                        data-test-subj='transfer-type'
                    />
                </EuiFormRow>

                {selectedTransferType ? (
                    selectedTransferType === "0" ? (
                        <Fragment>
                            <EuiFormRow label="Beneficiary account bank"
                                        isInvalid={(bankFieldMeta.error && bankFieldMeta.touched) ? true : false}
                                        error={bankFieldMeta.error}>
                                <EuiSelect
                                    options={deliveryBanks}
                                    onChange={onBankChange}
                                    value={bank}
                                    isInvalid={(bankFieldMeta.error && bankFieldMeta.touched) ? true : false}
                                    disabled={readonly}
                                />
                            </EuiFormRow>
                            <EuiFormRow label="Beneficiary account bank branch"
                                        isInvalid={(bankBranchMeta.error && bankBranchMeta.touched) ? true : false}
                                        error={bankBranchMeta.error}>
                                <EuiSelect
                                    options={bankBranches}
                                    onChange={onBankBranchChange}
                                    value={bankBranch}
                                    isInvalid={(bankBranchMeta.error && bankBranchMeta.touched) ? true : false}
                                     disabled={readonly}
                                />
                            </EuiFormRow>
                            <EuiFormRow label="Beneficiary account number"
                                        isInvalid={(bankAccountFieldMeta.error && bankAccountFieldMeta.touched) ? true : false}
                                        error={bankAccountFieldMeta.error}>
                                <EuiFieldText onChange={onBankAccount} value={bankAccount}
                                              disabled={readonly}
                                              isInvalid={(bankAccountFieldMeta.error && bankAccountFieldMeta.touched) ? true : false}/>
                            </EuiFormRow>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <EuiFormRow label="Branch"
                                        isInvalid={(formik.getFieldMeta('DeliveryOffice').error && formik.getFieldMeta('DeliveryOffice').touched) ? true : false}
                                        error={formik.getFieldMeta('DeliveryOffice').error}>
                                <EuiSelect
                                    options={offices}
                                    onChange={onBranchChange}
                                     disabled={cashierDisabled}

                                    value={selectedBranch}
                                    isInvalid={(formik.getFieldMeta('DeliveryOffice').error && formik.getFieldMeta('DeliveryOffice').touched) ? true : false}
                                />
                            </EuiFormRow>
                            <EuiFormRow label="Zoba"
                                        isInvalid={(formik.getFieldMeta('DeliveryOfficeZoba').error && formik.getFieldMeta('DeliveryOfficeZoba').touched) ? true : false}
                                        error={formik.getFieldMeta('DeliveryOfficeZoba').error}>
                                <EuiFieldText
                                    disabled={true}
                                    {...formik.getFieldProps('DeliveryOfficeZoba')}
                                    isInvalid={(formik.getFieldMeta('DeliveryOfficeZoba').error && formik.getFieldMeta('DeliveryOfficeZoba').touched) ? true : false}
                                />
                            </EuiFormRow>
                        </Fragment>
                    )
                ) : (
                    ""
                )}
            </EuiDescribedFormGroup>
        </Fragment>
    );
};

export default observer(TransferTypeSection);
